import { useState } from 'react';

const INITIAL_FILTER_VALUES = {
  filterDraft: false,
  filterPendingApproval: false,
  filterApproved: false,
};

type FilterValueTypes = keyof typeof INITIAL_FILTER_VALUES;
export type FiltersType = Record<FilterValueTypes, boolean>;

export const useFilters = () => {
  const [lastActiveFilters, setLastActiveFilters] = useState<FiltersType>(
    INITIAL_FILTER_VALUES,
  );
  const [filterDropdownStates, setFilterDropdownStates] = useState<FiltersType>(
    INITIAL_FILTER_VALUES,
  );

  const isFiltersChanged = Object.entries(lastActiveFilters).some(
    ([key, value]) => filterDropdownStates[key as FilterValueTypes] !== value,
  );

  const updateDraftFilter = () =>
    setFilterDropdownStates((prevState) => ({
      ...prevState,
      filterDraft: !prevState.filterDraft,
    }));
  const updatePendingApprovalFilter = () =>
    setFilterDropdownStates((prevState) => ({
      ...prevState,
      filterPendingApproval: !prevState.filterPendingApproval,
    }));
  const updateApprovalFilter = () =>
    setFilterDropdownStates((prevState) => ({
      ...prevState,
      filterApproved: !prevState.filterApproved,
    }));

  const updateLastDraftFilter = () =>
    setLastActiveFilters((prevState) => ({
      ...prevState,
      filterDraft: !prevState.filterDraft,
    }));
  const updateLastPendingApprovalFilter = () =>
    setLastActiveFilters((prevState) => ({
      ...prevState,
      filterPendingApproval: !prevState.filterPendingApproval,
    }));
  const updateLastApprovalFilter = () =>
    setLastActiveFilters((prevState) => ({
      ...prevState,
      filterApproved: !prevState.filterApproved,
    }));

  const clearAllFilters = () => {
    setFilterDropdownStates(INITIAL_FILTER_VALUES);
    setLastActiveFilters(INITIAL_FILTER_VALUES);
  };
  const onApplyFilters = () => setLastActiveFilters(filterDropdownStates);

  return {
    filterDropdownStates,
    lastActiveFilters,
    isFiltersChanged,
    actions: {
      updateDraftFilter,
      updatePendingApprovalFilter,
      updateApprovalFilter,
      updateLastDraftFilter,
      updateLastPendingApprovalFilter,
      updateLastApprovalFilter,
      clearAllFilters,
      onApplyFilters,
    },
  };
};
